import { mergePolicyDetail } from 'actions/policies';
import { setRequestErrored, setRequestInProcess } from 'actions/request';
import {
  EStudentChecklistRequestTypes,
  StudentChecklistRequest,
} from 'features/studentChecklist/models';
import { APIResponseError } from 'models/error';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import endpoint from 'shared/api';

import { updateAndCompleteStudentChecklist } from '../api/updateAndCompleteStudentChecklist';

export const useUploadStudentChecklistDocument = () => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState<'SUCCESS' | 'ERROR'>();

  const uploadStudentChecklistDocument = async (
    userPolicyId: string,
    documentName: keyof StudentChecklistRequest,
    file: File
  ) => {
    const requestType = EStudentChecklistRequestTypes.UPLOAD_DOCUMENT;
    dispatch(setRequestInProcess(true, requestType));

    try {
      const {
        data: { id, presignedUrl },
      } = await endpoint.createStudentChecklistUpload(userPolicyId, file.name);
      const updatedChecklist: StudentChecklistRequest = {
        [documentName]: id,
      };
      await endpoint.uploadStudentChecklistDocument(presignedUrl, file);
      await updateAndCompleteStudentChecklist(userPolicyId, updatedChecklist);
      // TODO: remove this when we have a better way to update the policy
      const { data } = await endpoint.getPolicyDetail(userPolicyId);
      dispatch(mergePolicyDetail(data));
      dispatch(setRequestInProcess(false, requestType));
      setStatus('SUCCESS');
    } catch (error) {
      dispatch(setRequestErrored(error as APIResponseError, requestType));
      setStatus('ERROR');
    }
  };

  return {
    requestFn: uploadStudentChecklistDocument,
    status,
  };
};
